import { Injectable } from '@angular/core';
import { DocumentResource, Resource, Service } from 'ngx-jsonapi';

import { User } from './user.service';

export class EventParticipation extends Resource {
  public override attributes = {
    status: 0,
    can_edit: false,
    invited_at: '',
    responded_at: null as string | null,
  };

  public override relationships = {
    user: new DocumentResource<User>(),
  };
}

@Injectable({
  providedIn: 'root',
})
export class EventParticipationService extends Service<EventParticipation> {
  public override resource = EventParticipation;
  public override type = 'EventParticipation';
  public override path = '/api/event-participations';
}
